import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    // If using browser back/forward, restore previous position
    if (savedPosition) {
      return savedPosition
    }
    
    // If navigating to a hash anchor
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    
    // If clicking on the same page (same path), scroll to top smoothly
    if (to.path === from.path) {
      return { top: 0, behavior: 'smooth' }
    }
    
    // For navigation to different pages, scroll to top instantly
    return { top: 0 }
  },
}
